import { render, staticRenderFns } from "./detailInform.vue?vue&type=template&id=bc46c31e"
import script from "./detailInform.vue?vue&type=script&lang=js"
export * from "./detailInform.vue?vue&type=script&lang=js"
import style0 from "./detailInform.vue?vue&type=style&index=0&id=bc46c31e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports